import ListingsByUser from './ListingsByUser';

export default ListingsByUser;
